export default "__VITE_ASSET__Dgsk5529__"